import { AWS_API_URL } from 'global/environment';
import { authorize, deleteRequest } from 'utils/http';

export async function deleteTimeProfilesAPI(id) {
  const url = `${AWS_API_URL}/2n/time-profiles/${id}`;

  return deleteRequest(url, await authorize());
}
